import React, { useEffect, useRef, useState } from 'react';
import AlmeEndLiveChatDialog from './AlmeEndLiveChatDialog';
import styled from 'styled-components';
import Button from 'syf-component-library/ui/atoms/Button';
import AlmeLiveChatOperatorTypingResponse, { isLiveChatOperatorTypingResponse } from './AlmeLiveChatOperatorTypingResponse';
import { Container } from '../../AlmeResponse/AlmeResponse.styles';
const ControlContainer = styled(Container) `
  display: flex;
  flex-direction: row;
  align-items: baseline;
  justify-content: space-between;
  margin: 0px;
`;
const StyledButton = styled(Button) `
    margin: 0px;
    align-self: start;
    padding: 0px;
    text-transform: none;
`;
const AlmeLiveChatControls = (props) => {
    const [showDialog, setShowDialog] = useState(false);
    const returnFocusToElement = useRef(null);
    useEffect(() => {
        var _a;
        if (props.isDialogOpen) {
            (_a = document.getElementById('alme-end-live-chat-dialog-close')) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }, [props.response, props.isDialogOpen]);
    if (!props.isLiveChatConnected) {
        // eslint-disable-next-line
        return null;
    }
    const handleEndChatClick = () => {
        if (props.isDialogOpen) {
            props.onEndChat('User');
        }
        // eslint-disable-next-line
        else {
            returnFocusToElement.current = document.activeElement;
            setShowDialog(true);
            props.setIsDialogOpen(true);
        }
    };
    const cancelDialogClick = () => {
        setTimeout(() => {
            var _a;
            (_a = returnFocusToElement.current) === null || _a === void 0 ? void 0 : _a.focus();
        }, 10);
        setShowDialog(false);
        props.setIsDialogOpen(false);
    };
    const endChat = () => {
        props.onEndChat("User");
        setShowDialog(false);
        props.setIsDialogOpen(false);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(ControlContainer, null,
            React.createElement(StyledButton, Object.assign({ onClick: handleEndChatClick, buttonType: 'ghost', id: 'alme-live-chat-end-button' }, props.focusProps), props.appConfig.liveChatControls.buttonText),
            !props.response.fromHistory && isLiveChatOperatorTypingResponse(props.response)
                ? React.createElement(AlmeLiveChatOperatorTypingResponse, { response: props.response, appConfig: props.appConfig, markUsedResponse: props.markUsedResponse })
                : null),
        React.createElement(AlmeEndLiveChatDialog, { isOpen: showDialog, appConfig: props.appConfig, onCancelClick: cancelDialogClick, onEndClick: endChat })));
};
export default AlmeLiveChatControls;
